<template>
  <Collapse simple class="collapse-warpper" value="1">
    <Panel name="3" class="collapse-panel">
      <span class="panel-title">{{initdata.title}}</span>
      <div slot="content">
          <div v-for="(item, index) in initdata.selectList" :key="index" style="margin-bottom: 10px">
            <span style="margin-right:10px">{{initdata.selectList[index].title}}</span>
            <Select v-model="item.model" style="width:183px;background:#f1f1f1" @on-change="change(item.value, $event)" placeholder="默认">
              <Option v-for="(item1, index1) in item.list" :value="item1.value" :key="index1">{{ item1.label }}</Option>
            </Select>
          </div>
      </div>
    </Panel>
  </Collapse>
</template>

<script>
export default {
  mounted() {},
  props: ["initdata", "filterListIndex"],
  data() {
    return {
      type: "",
      value: "",
    };
  },
  methods: {
    reset() {
      this.initdata.selectList.forEach(item => {
        item.model = ''
      })
      this.$emit("event", {
        fn: "reset"
      });
    },
    change(key, val) {
      this.$emit("event", {
        fn: 'sort',
        params: {
          key: key,
          val: val
        }
      })
    }
  },
  computed: {
    typeList: function() {
      return this.initdata.type;
    },
    valueList: function() {
      return this.initdata.value;
    }
  },
  watch: {},
  components: {}
};
</script>
<style scoped lang="less">
@import "./collapse.less";
.state-list {
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.state-item {
  width: 62px;
  height: 26px;
  line-height: 26px;
  border-radius: 4px;
  border: 1px solid transparent;
  text-align: center;
  cursor: pointer;
}
</style>

